import { ApolloError, OperationVariables } from '@apollo/client'
import { DocumentNode, OperationDefinitionNode, OperationTypeNode } from 'graphql'

export class ApolloOperationError extends ApolloError {
  readonly operationDoc: DocumentNode
  readonly operationVariables: OperationVariables
  readonly operationDefinition?: OperationDefinitionNode
  readonly operationType?: OperationTypeNode
  readonly operationName?: string

  constructor(apolloError: ApolloError, doc: DocumentNode, variables: OperationVariables = {}) {
    super(apolloError ? { ...apolloError } : {})
    this.operationDoc = doc
    this.operationVariables = variables
    this.operationDefinition = this.operationDoc.definitions.find(
      (definition) => definition.kind === 'OperationDefinition' && definition.name !== undefined,
    ) as OperationDefinitionNode

    this.operationType = this.operationDefinition?.operation
    this.operationName =
      typeof this.operationDefinition?.name === `string`
        ? this.operationDefinition?.name
        : this.operationDefinition?.name?.value
  }
}
